export enum PlatformChannel {
  MOBILE_APP = 'MOBILE_APP',
  BROWSER = 'BROWSER',
  ENTERPRISE = 'ENTERPRISE',
}
